// The same build works at the original origin and behind the shop's Worker.
export const appBase = /^\/bikebuilder(?:\/|$)/.test(window.location.pathname) ? '/bikebuilder' : '';
export function localAsset(url) {
  return url && /^\/(?:uploads|resources)\//.test(url) ? appBase + url : url;
}
